// extracted by mini-css-extract-plugin
export default {"socketAdminSendMsgForm":"SocketAdmin_socketAdminSendMsgForm__r9nbZ","socketAdminInput":"SocketAdmin_socketAdminInput__-2yDO","socketAdminBtn":"SocketAdmin_socketAdminBtn__L8vW-"};